import React, { Component, Fragment } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { COLORS } from '../styles/colors';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';

const styles = theme => ({
	root: {
		margin: 0,
		padding: theme.spacing(2),
	},
	closeButton: {
		position: 'absolute',
		right: theme.spacing(1),
		top: theme.spacing(1),
		color: theme.palette.grey[500],
	},
});

const acceptTypes = {
    mixed: ['image/gif', 'image/jpeg', 'image/jpg', 'image/png', 'video/mp4', 'video/mov'],
    video: ['video/mp4', 'video/quicktime'],
    image: ['image/gif', 'image/jpeg', 'image/jpg', 'image/png'],
    audio: ['.mp3', '.m4a']
  }

  
const DialogTitle = withStyles(styles)(props => {
	const { children, classes, onClose, ...other } = props;
	return (
		<MuiDialogTitle disableTypography className={classes.root} {...other}>
			<Typography variant="h6">{children}</Typography>
			{onClose ? (
				<IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
					<CloseIcon />
				</IconButton>
			) : null}
		</MuiDialogTitle>
	);
});

const DialogContent = withStyles(theme => ({
	root: {
		padding: theme.spacing(2),
	},
}))(MuiDialogContent);

export default class FilePreviewButton extends Component {
	
	render() {
		
       const { item, isOpen, handleClose } = this.props;
       const fileType = item && item.fileType.toLowerCase();

       return (
			<Fragment>
     			   <Dialog onClose={() => {
                        handleClose()
                    }} aria-labelledby="customized-dialog-title" open={isOpen}>
                   <DialogTitle id="customized-dialog-title" onClose={() => {
                       handleClose()
                   }}>
                       Preview
                   </DialogTitle>
                   <DialogContent dividers>
                       <Typography gutterBottom>
                           <div className="modalBody modal-content" style={{ width: 320 }}>
                               <div style={{
                                   display: 'flex',
                                   flexDirection: 'column'
                               }}>
                                   <div style={{
                                       display: 'flex',
                                       justifyContent: 'center',
                                       width: '100%'
                                   }}>
                                       { acceptTypes["mixed"].includes('image/' + fileType) 
                                        ?  <img src={item.url} alt={item.name} /> :
                                           <video controls src={item.url} autoPlay style={{ width: '100%', height: 200, objectFit: 'fill' }} loop />
                                       }
                                   </div>
                                   <div style={{
                                       backgroundColor: COLORS.greyFour,
                                       padding: 10,
                                       justifyContent: 'center',
                                       alignItems: 'center'
                                   }}>
                                       <div style={{
                                           display: 'flex',
                                           flexDirection: 'column',
                                           alignItems: 'center'
                                       }}>
                                           
                                           
                                       </div>
                                   </div>
                               </div>
                           </div>
                       </Typography>
                   </DialogContent>
                </Dialog>
            </Fragment>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/FilePreviewButton.js